import styled, { css } from 'styled-components';

import { type IconsType } from './Icon';

export const Wrapper = styled.div<{ $icon: IconsType }>`
    flex-shrink: 0;

    display: flex;
    align-items: center;
    justify-content: center;

    svg {
        width: 22px;
        height: 22px;
    }

    ${({ $icon }) =>
        $icon === 'plus' &&
        css`
            svg {
                width: 18px;
                height: 18px;
            }
        `}

    ${({ $icon }) =>
        $icon === 'settings' &&
        css`
            svg {
                width: 26px;
                height: 26px;
            }
        `}

    @media (max-width: 768px) {
        svg {
            width: 24px;
            height: 24px;
        }

        ${({ $icon }) =>
            $icon === 'search' &&
            css`
                svg {
                    width: 28px;
                    height: 28px;
                }
            `}
    }
`;
